exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "#wpgp-tinymce-popup-container-body {\n  padding: 10px 16px; }\n\ni.mce-i-icons {\n  display: inline-block;\n  -webkit-font-smoothing: antialiased;\n  font: normal 20px/1 'dashicons';\n  vertical-align: top; }\n", ""]);
